import api from './axios';

export const providerBookingApi = {
  list: (group) => api.get('/provider/bookings', { params: group ? { group } : {} }).then((r) => r.data),
  detail: (id) => api.get(`/provider/bookings/${id}`).then((r) => r.data),
  respond: (id, action) => api.patch(`/provider/bookings/${id}/respond`, { action }).then((r) => r.data),
  startJob: (id) => api.patch(`/provider/bookings/${id}/start`).then((r) => r.data),
  endJob: (id) => api.patch(`/provider/bookings/${id}/end`).then((r) => r.data),
  respondExtraHours: (id, reqId, action, hours) =>
    api.patch(`/provider/bookings/${id}/extra-hours/${reqId}`, hours == null ? { action } : { action, hours }).then((r) => r.data),
  cancel: (id, detail) => api.patch(`/provider/bookings/${id}/cancel`, { detail }).then((r) => r.data),

  // ── Payout statements (read-only; release is admin-only) ──
  payoutInvoice: (id) => api.get(`/provider/bookings/${id}/payout-invoice`).then((r) => r.data),
  listPayouts: () => api.get('/provider/payouts').then((r) => r.data),
};

export default providerBookingApi;
